import routeCodes from 'common/constants/route-codes';
import store from 'redux/store';

class RouterHelper {
  static getRouteName = (location) => {
    const { pathname } = location;
    let name;
    Object.keys(routeCodes).forEach((key) => {
      const path = routeCodes[key];
      if (pathname.includes(path)) {
        name = key;
      }
    });
    return name;
  };

  static getRouteWithRestaurantId = (path) => {
    if (path.includes('menu')) {
      const {
        common: { currentRestaurant },
      } = store.getState();
      return path.replace(':restaurantId', currentRestaurant?.id);
    }
    return path;
  };

  static getBreadcrumbLink = (adminRoute, superAdminRoute, isSuperAdmin) => {
    if (isSuperAdmin && superAdminRoute) {
      return RouterHelper.getRedirectRouteWithRestaurantId(superAdminRoute);
    }
    return adminRoute;
  };

  static getBreadcrumbItems = (pathname, homePage = 'Home', isSuperAdmin) => {
    let isInitDynamicRestaurantTitle = false;
    const {
      common: { currentRestaurant },
    } = store.getState();

    const items = [
      {
        link: '/',
        label: isSuperAdmin ? homePage : currentRestaurant?.title || homePage,
      },
    ];
    const splitPaths = pathname.split('/').filter(Boolean);
    if (pathname === '/') {
      items.push({
        link: '/',
        label: 'Home',
      });
    }

    splitPaths.forEach((path) => {
      const isDynamic = Number.isInteger(parseInt(path));
      if (!isInitDynamicRestaurantTitle && isDynamic && currentRestaurant?.id) {
        items.push({
          link: `/restaurants/${currentRestaurant?.id}`,
          label: currentRestaurant?.title,
        });
        isInitDynamicRestaurantTitle = true;
      }
      if (path.includes('profile')) {
        items.push({
          link: '/profile',
          label: 'Profile',
        });
      }
      if (path.includes('administration')) {
        items.push({
          link: '/administration',
          label: 'Amministrazione',
        });
      }
      if (path.includes('company')) {
        items.push({
          link: routeCodes.superAdmin.administrationCompany,
          label: 'Crea società',
        });
      }
      if (path.includes('owners')) {
        items.push({
          link: routeCodes.superAdmin.administrationOwners,
          label: 'Crea gestore',
        });
      }
      // if (path.includes('restaurants')) {
      //   items.push({
      //     link: routeCodes.superAdmin.administrationRestaurant,
      //     label: 'Crea insegna',
      //   });
      // }
      if (path === 'restaurant') {
        items.push({
          link: '/profile/restaurant/create',
          label: 'Anagrafica insegna',
        });
      }
      if (path === 'bonuses') {
        items.push({
          link: '/bonuses',
          label: 'Crea offerte',
        });
      }
      if (path === 'reminder') {
        items.push({
          link: '/reminder',
          label: 'Reminder',
        });
      }

      if (path === 'reservations') {
        items.push({
          link: '/reservations',
          label: 'Prenotazioni',
        });
      }

      if (path === 'firm') {
        items.push({
          link: '/profile/firm/create',
          label: 'Anagrafica gestora',
        });
      }
      if (path === 'all-bonuses') {
        items.push({
          link: '/all-bonuses',
          label: 'Buoni RistoraBergamo',
        });
      }
      if (path === 'menu') {
        items.push({
          link: RouterHelper.getBreadcrumbLink(
            routeCodes.menu,
            routeCodes.superAdmin.menu,
            isSuperAdmin,
          ),
          label: 'Menù',
        });
      }
      if (path === 'dishes') {
        items.push({
          link: RouterHelper.getBreadcrumbLink(
            routeCodes.menuDishesCreate,
            routeCodes.superAdmin.menuDishesCreate,
            isSuperAdmin,
          ),
          label: 'Crea piatto/prodotto',
        });
      }
      if (path === 'home') {
        items.push({
          link: routeCodes.superAdmin.restaurantHome.replace(
            ':restaurantId',
            currentRestaurant?.id,
          ),
          label: 'home',
        });
      }
      if (path === 'categories') {
        items.push({
          link: RouterHelper.getBreadcrumbLink(
            routeCodes.menuCategoriesCreate,
            routeCodes.superAdmin.menuCategoriesCreate,
            isSuperAdmin,
          ),
          label: 'Crea categorie',
        });
      }
      if (path === 'special-menu') {
        items.push({
          link: RouterHelper.getBreadcrumbLink(
            routeCodes.specialMenuCreate,
            routeCodes.superAdmin.specialMenuCreate,
            isSuperAdmin,
          ),
          label: 'Crea menù speciale',
        });
      }
      if (path === 'options') {
        items.push({
          link: RouterHelper.getBreadcrumbLink(
            routeCodes.menuOptionsCreate,
            routeCodes.superAdmin.menuOptionsCreate,
            isSuperAdmin,
          ),
          label: 'Crea opzione',
        });
      }
      if (path === 'settings') {
        items.push({
          link: RouterHelper.getBreadcrumbLink(
            routeCodes.settings,
            routeCodes.superAdmin.settings,
            isSuperAdmin,
          ),
          label: 'Impostazioni',
        });
      }
      if (path === 'ipratico') {
        items.push({
          link: RouterHelper.getBreadcrumbLink(
            routeCodes.ipratico,
            routeCodes.superAdmin.ipratico,
            isSuperAdmin,
          ),
          label: 'Ipratico',
        });
      }
      if (path === 'statistics') {
        items.push({
          link: RouterHelper.getBreadcrumbLink(
            routeCodes.statistics,
            routeCodes.superAdmin.statistics,
            isSuperAdmin,
          ),
          label: 'Statistiche',
        });
      }
      if (path === 'qr') {
        items.push({
          link: RouterHelper.getBreadcrumbLink(
            routeCodes.generateQR,
            routeCodes.superAdmin.generateQR,
            isSuperAdmin,
          ),
          label: 'Genera Codice QR code',
        });
      }
      if (path === 'restaurants') {
        items.push({
          link: routeCodes.restaurants,
          label: 'Ristoratori-Produttori',
        });
      }
      if (path === 'team') {
        items.push({
          link: RouterHelper.getBreadcrumbLink(
            routeCodes.team,
            routeCodes.superAdmin.team,
            isSuperAdmin,
          ),
          label: 'Team',
        });
      }
      if (path === 'finances') {
        items.push({
          link: RouterHelper.getBreadcrumbLink(
            routeCodes.finances,
            routeCodes.superAdmin.finances,
            isSuperAdmin,
          ),
          label: 'Fatture',
        });
      }
      if (path === 'help') {
        items.push({
          link: RouterHelper.getBreadcrumbLink(
            routeCodes.help,
            routeCodes.superAdmin.help,
            isSuperAdmin,
          ),
          label: 'Aiuto',
        });
      }
      if (path === 'offers') {
        items.push({
          link: RouterHelper.getBreadcrumbLink(
            routeCodes.offers,
            routeCodes.superAdmin.offers,
            isSuperAdmin,
          ),
          label: 'Offerte',
        });
      }
      if (path === 'notifications') {
        items.push({
          link: routeCodes.superAdmin.notifications,
          label: 'Area notifiche',
        });
      }
      if (path === 'bonus-amount') {
        items.push({
          link: RouterHelper.getBreadcrumbLink(
            routeCodes.offersCreatBonusAmount,
            routeCodes.superAdmin.offersCreatBonusAmount,
            isSuperAdmin,
          ),
          label: 'Crea offerta',
        });
      }
      if (path === 'bonus-payment') {
        items.push({
          link: RouterHelper.getBreadcrumbLink(
            routeCodes.offersCreatPayment,
            routeCodes.superAdmin.offersCreatPayment,
            isSuperAdmin,
          ),
          label: 'Crea offerta',
        });
      }
      if (path === 'register') {
        items.push({
          link: routeCodes.register,
          label: 'Registro COVID-19',
        });
      }
      if (path === 'bonus-calendar') {
        items.push({
          link: RouterHelper.getBreadcrumbLink(
            routeCodes.offersCreatCalendar,
            routeCodes.superAdmin.offersCreatCalendar,
            isSuperAdmin,
          ),
          label: 'Crea offerta',
        });
      }
    });

    return items;
  };

  static getRedirectRouteWithRestaurantId = (
    path = routeCodes.home,
    restaurantId,
  ) => {
    const {
      common: { currentRestaurant },
    } = store.getState();

    return path.replace(':restaurantId', restaurantId || currentRestaurant?.id);
  };

  static getRouteWithRestaurant = (path) => {
    const {
      common: { currentRestaurant },
    } = store.getState();
    return path.replace(':restaurantId', currentRestaurant?.id);
  };

  static correctionPathForSuperAdmin = (path) => {
    const {
      common: { currentRestaurant },
      user: { isSuperAdmin },
    } = store.getState();
    if (!isSuperAdmin) {
      return path;
    }

    return path.replace(':restaurantId', currentRestaurant?.id);
  };
}

export default RouterHelper;
